<nav class="navbar-dark bg-dark fixed-bottom">
  <span class="navbar-text">
    &nbsp; {{version}} (Server: {{serverVersion}})
  </span>
  <span class="navbar-text">
    &nbsp; Status: {{connectionStatus}}
  </span>
  <span class="dot"></span>
</nav>
